import { Component, OnInit, HostListener } from '@angular/core';
import * as $ from 'jquery';
import { TweenMax } from 'gsap';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    // TweenMax.set (".design-move", {zIndex:1000});
    // TweenMax.set (".code-move", {zIndex:1000});
    // TweenMax.set (".video-move", {zIndex:1000});
    
    // if($('.wrap').width() < 768 ){
    //   TweenMax.killAll();
    // } else {
    //   this.homeAnim();
    // }

    this.homeAnim();
  }

  killall() {

  }

  homeAnim() {
    
      $(".wrap").mousemove(function(e) {
        parallaxIt(e, ".hero-move", 70);
        parallaxIt(e, ".video-move", -70);
        parallaxIt(e, ".design-move", -70);
        parallaxIt(e, ".code-move", 70);
      });

      function parallaxIt(e, target, movement) {
        var $this = $(".wrap");
        var relX = e.pageX - $this.offset().left;
        var relY = e.pageY - $this.offset().top;

        TweenMax.to(target, 1, {
          x: (relX - $this.width() / 2) / $this.width() * movement,
          y: (relY - $this.height() / 2) / $this.height() * movement
        });

        
        

      }   

  
  }

}
